export const SPINNER_TESTIDS = {
    SPINNER_SMALL: 'SPINNER_SPINNER_SMALL',
};
